/**
 * Filtro de warnings para desarrollo
 * Suprime warnings conocidos que no afectan la funcionalidad
 */

// Guardar la función original de console.warn
const originalWarn = console.warn;

// Sobrescribir console.warn para filtrar warnings específicos
console.warn = function(...args) {
  const message = args.join(' ');
  
  // Lista de warnings que podemos ignorar de forma segura
  const ignoredWarnings = [
    'Cross-Origin-Opener-Policy policy would block',
    'gapi.loaded_0',
    'fedcm_migration_mod'
  ];
  
  // Si el warning contiene alguna de las frases ignoradas, no lo mostramos
  const shouldIgnore = ignoredWarnings.some(warning => 
    message.includes(warning)
  );
  
  if (!shouldIgnore) {
    originalWarn.apply(console, args);
  }
};

// Mensaje informativo para desarrolladores
console.log('🔇 Warnings de COOP filtrados para mejorar la experiencia de desarrollo');
